import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import moment from 'moment';
import { Moment } from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { UntypedFormControl } from '@angular/forms';

import { FormFieldComponent } from '../form-field.types';
import { Activity } from 'app/core/models';

@Component({
  templateUrl: './date-form-field.component.html',
  styleUrls: ['./date-form-field.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class DateFormFieldComponent extends FormFieldComponent implements OnInit {
  @ViewChild('inputControl') inputControl: ElementRef;

  dateDisplayFormat = 'MM/DD/YYYY';

  editing = false;
  showHistory = false;
  activities: Activity[];
  date = new UntypedFormControl(null);

  private originalValue: string;

  get displayValue(): string {
    return 'REDACTED';
  }

  get modelFieldValue(): string {
    return this.model[this.fieldDef.name];
  }

  get modelFieldMomentValue(): Moment {
    return moment(this.modelFieldValue || '');
  }

  get modelFieldFormattedValue(): string {
    return this.modelFieldMomentValue?.format(this.dateDisplayFormat);
  }

  get dateFieldFormattedValue(): string {
    return this.date.value?.format(this.dateDisplayFormat);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.originalValue = this.modelFieldFormattedValue;
    if (this.fieldDef.meta?.readonly) this.readonly = this.fieldDef.meta.readonly;

    this.date.setValue(this.modelFieldMomentValue);
    this.model[this.fieldDef.name] = this.date.value;
  }

  onDateChange(): void {
    if (this.originalValue !== this.dateFieldFormattedValue) {
      const dbFormattedDate = this.date.value?.format('YYYY-MM-DD');
      if (dbFormattedDate) this.save(dbFormattedDate);
      else this.date.setErrors({ incorrect: true });
    }
  }

  dateBlur(event: FocusEvent & { target: HTMLInputElement }): void {
    if (event.target.value === '') {
      this.date.setValue(null);
      if (this.originalValue) this.save(this.date.value);
    }
  }

  save(date: string): void {
    this.model[this.fieldDef.name] = date;
    this.originalValue = this.dateFieldFormattedValue;
    this.update.emit({ [this.fieldDef.name]: date });
  }

  updateChangedModel?(model: any): void {
    this.model = model;
    this.date.setValue(this.modelFieldMomentValue);
  }
}
